import $ from 'jquery';
window.$ = $;
window.jQuery = $;

/**
 * Cập nhật bộ đếm điều kiện tìm kiếm đã lưu.
 * Trước đây đọc từ response.queries, nhưng server không còn phản chiếu lại mảng
 * điều kiện nữa (ticket 4149 [Security]) nên chỉ nhận về số lượng.
 */
function updateSessionSearchCount(count) {
    if (typeof count !== 'number') {
        return;
    }
    $('.count-session-search-table').text(count + '/10');
    $('.jsSessionSearchList .number').text(count);
    if (count > 0) {
        $('.jsSessionSearchList').addClass('jsLightboxCall').attr('data-lightbox', 'lightboxResult');
    } else {
        $('.jsSessionSearchList').removeClass('jsLightboxCall').removeAttr('data-lightbox');
    }
}

$(window).on('load', function () {
    $(document).on('click', '.jsSessionSearch', function (e) {
        e.preventDefault();
        let query = Object.fromEntries(new URLSearchParams(window.location.search));
        $.ajax({
            url: '/ajax/search',
            type: 'POST',
            credentials: 'same-origin',
            data: { query: query },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if (response.content) {
                    $('.session-search-table').html(response.content);
                }
                updateSessionSearchCount(response.count);
            }
        });
    });
    
    setTimeout(() => {
        $('.jsSessionSearchList').addClass('init');
    }, 100);
    $(document).on('click', '.jsSessionSearchList', function (e) {
        e.preventDefault();
        let currentCount = parseInt($(this).find('.number').text()) || 0;
        if (currentCount === 0) {
            return false;
        }
        $.ajax({
            url: '/ajax/search',
            type: 'GET',
            credentials: 'same-origin',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if (response.content) {
                    $('.session-search-table').html(response.content);
                }
                updateSessionSearchCount(response.count);
            }
        });
    });

    $(document).on('click', '.jsRemoveSessionSearch', function (e) {
        e.preventDefault();
        let index = $(this).data('index');
        $.ajax({
            url: '/ajax/search/delete',
            type: 'POST',
            credentials: 'same-origin',
            data: { index: index },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if (response.content) {
                    $('.session-search-table').html(response.content);
                }
                updateSessionSearchCount(response.count);
            }
        });
    });

    $(document).on('click', '.jsButtonContactSearch', async function (e) {
        e.preventDefault();
        let code = $(this).data('code');
        try {
            const res = await fetch('/lecturer/put-candidate', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({ code })
            });

        } catch (error) {
            // Handle error if needed
        }

        window.location.href = '/contact/lecture_in/form/';
    });

    const formSearchEl = document.getElementById('formSearch');
    if(formSearchEl) {
        formSearchEl.addEventListener('submit', (e) => {
            e.preventDefault();
            const url = new URL('/search', location.origin);
            let genreBValue = '', genreSValue = '';
            if(window.innerWidth > 768) {
                formSearchEl.querySelectorAll('[name="genreB"]').forEach((el) => {
                    if (el.type === 'radio' && el.checked) {
                        genreBValue = el.value;
                    }
                });
                formSearchEl.querySelectorAll('[name="genreS"]').forEach((el) => {
                    if (el.type === 'radio' && el.checked) {
                        genreSValue = el.value;
                    }
                });
            }else {
                genreBValue = $('#genreB_id').val();
                genreSValue = $('#genreS_id').val();
            }
            // If both genreB and genreS are selected, only pass genreS
            if (genreSValue) {
                url.searchParams.set('genreS', genreSValue);
            } else if (genreBValue) {
                url.searchParams.set('genreB', genreBValue);
            }
            if($('#money_code').val())url.searchParams.set('money_code', $('#money_code').val());
            if($('#style').val())url.searchParams.set('style', $('#style').val());
            if($('#gender').val())url.searchParams.set('gender', $('#gender').val());
            if($('#pref_id').val())url.searchParams.set('pref', $('#pref_id').val());
            if($('#lecturer').val())url.searchParams.set('keyword', $('#lecturer').val());
            location.href = url.toString();
        });
    }

    $(document).on('click', '.jsCheckboxCandidate', function (e) {
        const $cb = $(this);
        $cb.prop('disabled', true);
        $.ajax({
            url: '/ajax/lecturer/choice',
            type: 'POST',
            credentials: 'same-origin',
            data: {
                code: $(this).val(),
                checked: $(this).is(':checked') ? 1 : 0
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                $cb.prop('disabled', false);
                if (response.count > 0) {
                    $('.jsCandidate').removeAttr('data-state');
                } else {
                    $('.jsCandidate').not(':has(.jsCheckboxCandidate:checked)').attr('data-state', 'disabled');
                }
            },
            error: function() {
                $cb.prop('disabled', false);
            }
        });
    });
});

window.addEventListener('load', () => {
    const $form = $('#formSearch');

    if (!$form.length) {
        return;
    }

    const $keywordInput = $('#lecturer');

    function getGenreValues() {
        let genreBValue = '', genreSValue = '';
        const formEl = document.getElementById('formSearch');
        if (formEl && window.innerWidth > 768) {
            formEl.querySelectorAll('[name="genreB"]').forEach((el) => {
                if (el.type === 'radio' && el.checked) {
                    genreBValue = el.value;
                }
            });
            formEl.querySelectorAll('[name="genreS"]').forEach((el) => {
                if (el.type === 'radio' && el.checked) {
                    genreSValue = el.value;
                }
            });
        } else {
            genreBValue = $('#genreB_id').val();
            genreSValue = $('#genreS_id').val();
        }
        return { genreBValue, genreSValue };
    }

    const delay         = 300;
    const keywordDelay  = 600;
    let   debounceTimer = null,
          currentXhr    = null,
          lastRequestKey = null,
          isComposing   = false;

    $form
        .on('input', 'input:not([type=radio]):not([type=checkbox]), textarea', function (event) {
            if (event.target.id === 'lecturer' && isComposing) {
                return;
            }

            scheduleDebounce(event);
        })
        .on('change', 'select, input[type=radio], input[type=checkbox]', scheduleDebounce);

    $keywordInput
        .on('compositionstart', function () {
            isComposing = true;
            clearTimeout(debounceTimer);
        })
        .on('compositionend', function (event) {
            isComposing = false;
            scheduleDebounce(event);
        })
        .on('blur', function (event) {
            window.setTimeout(() => {
                isComposing = false;
                scheduleDebounce(event);
            }, 0);
        });

    function scheduleDebounce(event) {
        clearTimeout(debounceTimer);

        const debounceDelay = event?.target?.id === 'lecturer' ? keywordDelay : delay;
        debounceTimer = setTimeout(performDebounce, debounceDelay);
    }

    function performDebounce() {
        const { genreBValue, genreSValue } = getGenreValues();
        const params = new URLSearchParams($form.serialize());
        params.delete('genreB');
        params.delete('genreS');
        if (genreBValue) params.set('genreB', genreBValue);
        if (genreSValue) params.set('genreS', genreSValue);

        const keyword = params.get('keyword')?.trim() ?? '';
        if (keyword) {
            params.set('keyword', keyword);
        } else {
            params.delete('keyword');
        }

        if (!hasValidValue()) {
            lastRequestKey = null;
            $('#countSearch').text('0人');
            return;
        }

        const requestKey = params.toString();
        if (requestKey === lastRequestKey) {
            return;
        }

        lastRequestKey = requestKey;

        if (currentXhr && typeof currentXhr.abort === 'function') {
            currentXhr.abort();
            currentXhr = null;
        }

        currentXhr = $.ajax({
            url: '/ajax/search/count',
            type: 'get',
            dataType: 'json',
            data: params.toString(),
            success: function (res) {
                const count = res.count ?? 0;
                $('#countSearch').text(`${count}人`);
            },
            complete: function () {
                currentXhr = null;
            }
        });

    }

    function hasValidValue() {
        let valid = false;

        $form.find('input, select, textarea').each(function () {
            let val = $(this).val();

            if ((this.type === 'radio' || this.type === 'checkbox') && !this.checked) {
                return;
            }

            if (val === null || val === '') {
                return;
            }

            if (val == -1) {
                return;
            }

            valid = true;
            return false;
        });

        return valid;
    }
});